import React, { useState } from 'react';
import { Offcanvas, Nav,Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { 
  X, LogOut, User, ChevronDown, ChevronRight,
  LayoutDashboard, FileText, FolderTree, Users, 
  Mail, Settings, PlusCircle,MessageSquare 
} from 'lucide-react';
import profileImg from '../../../img/akash.jpg';
import '../css/MobileSidebar.css';

const MobileSidebar = ({ show, onHide }) => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});

  const menuItems = [
    { 
      icon: LayoutDashboard, 
      text: 'Dashboard', 
      path: '/admin',
      exact: true
    },
    { 
      icon: FileText, 
      text: 'Posts', 
      path: '/admin/posts',
      subItems: [
        { text: 'All Posts', path: '/admin/posts' },
        { text: 'Create New', path: '/admin/posts/create', icon: PlusCircle }
      ]
    },
    { 
      icon: FolderTree, 
      text: 'Categories', 
      path: '/admin/categories'
    },
    { 
      icon: Users, 
      text: 'Users', 
      path: '/admin/users'
    },
    { 
      icon: MessageSquare, 
      text: 'Messages', 
      path: '/admin/contact'
    },
    { 
      icon: Settings, 
      text: 'Settings3', 
      path: '/admin/settings3'
    },
      { 
      icon: FolderTree, 
      text: 'Categories3', 
      path: '/admin/categories3'
    },
    { 
      icon: Users, 
      text: 'Users2', 
      path: '/admin/users2'
    },
    { 
      icon: MessageSquare, 
      text: 'Messages2', 
      path: '/admin/contact2'
    },
    { 
      icon: Settings, 
      text: 'Settings2', 
      path: '/admin/settings2'
    },
      { 
      icon: FolderTree, 
      text: 'Categories1', 
      path: '/admin/categories1'
    },
    { 
      icon: Users, 
      text: 'Users1', 
      path: '/admin/users1'
    },
    { 
      icon: MessageSquare, 
      text: 'Messages1', 
      path: '/admin/contact1'
    },
    { 
      icon: Settings, 
      text: 'Settings1', 
      path: '/admin/settings1'
    },
  ];

  const toggleSubMenu = (index) => {
    setOpenMenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  const handleNavigation = () => {
    onHide();
  };

  return (
    <Offcanvas 
      show={show} 
      onHide={onHide} 
      className="mobile-sidebar-modern"
      placement="start"
    >
      <Offcanvas.Header className="mobile-sidebar-header px-0">
        <div className="mobile-user-section">
          <img src={profileImg} alt="Profile" className="mobile-avatar" />
          <div className="mobile-user-details">
            <div className="mobile-user-name">Akash G.C.</div>
            <div className="mobile-user-role">Super Admin</div>
          </div>
          <Button variant="ghost" className="close-sidebar-btn" onClick={onHide}>
            <X size={22} />
          </Button>
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body className="mobile-sidebar-body px-0">
        <div className="mobile-menu-wrapper">
          <Nav className="flex-column mobile-nav-menu w-100">
            {menuItems.map((item, index) => (
              <div key={index} className="mobile-menu-item">
                {item.subItems ? (
                  <>
                    <div 
                      className={`mobile-menu-link ${isActive(item.path) ? 'active' : ''}`}
                      onClick={() => toggleSubMenu(index)}
                    >
                      <item.icon size={20} />
                      <span className="menu-text">{item.text}</span>
                      {openMenus[index] ? 
                        <ChevronDown size={18} className="menu-arrow" /> : 
                        <ChevronRight size={18} className="menu-arrow" />
                      }
                    </div>
                    {openMenus[index] && (
                      <div className="mobile-submenu">
                        {item.subItems.map((subItem, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            className={`mobile-submenu-link ${isActive(subItem.path, true) ? 'active' : ''}`}
                            onClick={handleNavigation}
                          >
                            {subItem.icon && <subItem.icon size={16} />}
                            <span>{subItem.text}</span>
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className={`mobile-menu-link ${isActive(item.path, item.exact) ? 'active' : ''}`}
                    onClick={handleNavigation}
                  >
                    <item.icon size={20} />
                    <span className="menu-text">{item.text}</span>
                  </Link>
                )}
              </div>
            ))}
          </Nav>
        </div>

        <div className="mobile-menu-footer">
          <Link to="/admin/profile" className="mobile-footer-link" onClick={handleNavigation}>
            <User size={18} />
            <span>View Profile</span>
          </Link>
          <div className="mobile-footer-link logout" onClick={() => {
            console.log('logout');
            handleNavigation();
          }}>
            <LogOut size={18} />
            <span>Logout</span>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MobileSidebar;